<template>
  <div class="adres-page">
    <loadingcomp
      ref="loadingcomp"
      :mesaj="loadingmesaj"
      v-model="loadingvmodel"
    ></loadingcomp>

    <v-card class="page-shell" flat>
      <v-form ref="formadres" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12>
            <div class="hero-bar">
              <div class="hero-bar__left">
                <div class="hero-bar__badge">{{$t('Address-Card')}}</div>
                <h1 class="hero-bar__title">{{$t('Address_label')}}</h1>
              </div>

              <div class="hero-bar__right">
                <v-btn
                  v-if="islem != 'get'"
                  @click="ekle()"
                  class="action-btn action-btn--save"
                  depressed
                >
                  <v-icon left>add_box</v-icon>
                  {{$t("save_button")}}
                </v-btn>

                <v-btn
                  v-if="islem == 'get'"
                  @click="guncelle()"
                  class="action-btn action-btn--update"
                  depressed
                >
                  <v-icon left>edit</v-icon>
                  {{$t('Update')}}
                </v-btn>
              </div>
            </div>
          </v-flex>

          <v-flex xs12>
            <v-tabs
              class="modern-tabs"
              v-model="active"
              color="transparent"
              slider-color="#2563eb"
            >
              <v-tab href="#0">{{$t("tab_general")}}</v-tab>
              <v-tab href="#1">{{ $t('Passport-DETAILS') }}</v-tab>
              

              <!-- GENEL -->
              <v-tab-item :id="'0'" class="tab-panel">
                <v-layout row wrap>
                  <v-flex xs12 md8 pa-2>
                    <v-card class="modern-card" flat>
                      <div class="section-head">
                        <div>
                          <h3>{{$t('Personal-Information')}}</h3>
                          <span>{{$t('Basic-Identity-and-Contact-Fields')}}</span>
                        </div>
                      </div>

                      <v-card-text class="modern-card__body">
                        <v-layout row wrap>
                          <v-flex xs12 sm6 md4>
                            <v-text-field
                              hide-details
                              mask="###########"
                              :label="$t('Identitynumber_label')"
                              v-model="Adres.TCKimlikNo"
                              outlined
                              class="modern-input"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 sm6 md4>
                            <v-select
                              :items="itemscinsiyet"
                              hide-details
                              v-model="Adres.Cinsiyet"
                              item-text="text"
                              item-value="value"
                              clearable
                              :label="$t('Sex')"
                              outlined
                              class="modern-input"
                            ></v-select>
                          </v-flex>

                          <v-flex xs12 sm6 md4>
                            <tarihim
                              :etiket="$t('Date-of-Birth')"
                              :value="Adres.DogumTarihi"
                              :detaygizle="true"
                              v-model="Adres.DogumTarihi"
                              :defaultvalue="'no'"
                            ></tarihim>
                          </v-flex>

                          <v-flex xs12 sm6>
                            <v-text-field
                              hide-details
                              :rules="[v => (!!v && v.length <= 50) || $t('Must-be-characters-maximum')]"
                              :label="$t('Name_label')"
                              v-model="Adres.Ad"
                              outlined
                              class="modern-input"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 sm6>
                            <v-text-field
                              hide-details
                              :rules="[v => (v == null || v.length <= 50) || $t('Must-be-characters-maximum')]"
                              :label="$t('Surname_label')"
                              v-model="Adres.Soyad"
                              outlined
                              class="modern-input"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 sm6>
                            <v-text-field
                              hide-details
                              label="GSM"
                              v-model="Adres.GSM"
                              outlined
                              class="modern-input"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 sm6>
                            <v-text-field
                              hide-details
                              :label="$t('Email_label')"
                              v-model="Adres.Email"
                              outlined
                              class="modern-input"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12>
                            <v-textarea
                              v-model="Adres.Adres"
                              :label="$t('Address_label')"
                              outlined
                              rows="3"
                              class="modern-input"
                            ></v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <v-flex xs12 md4 pa-2>
                    <v-card class="modern-card modern-card--side" flat>
                      <div class="section-head">
                        <div>
                          <h3>{{$t('Preferences-and-Notes')}}</h3>
                          <span>{{$t('Customer-Habits-and-Remarks')}}</span>
                        </div>
                      </div>

                      <v-card-text class="modern-card__body">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <div class="check-group">
                              <v-checkbox
                                :label="$t('Requires-Online-Check-in')"
                                v-model="Adres.OnlineCIn"
                                hide-details
                                class="modern-check"
                              ></v-checkbox>

                              <v-checkbox
                                :label="$t('Smokes')"
                                v-model="Adres.Sigara"
                                hide-details
                                class="modern-check"
                              ></v-checkbox>
                            </div>
                          </v-flex>

                          <v-flex xs12>
                            <v-textarea
                              v-model="Adres.Notlar"
                              :label="$t('Notes')"
                              outlined
                              rows="4"
                              class="modern-input"
                            ></v-textarea>
                          </v-flex>

                          <v-flex xs12>
                            <v-textarea
                              v-model="Adres.RezIstekleri"
                              :label="$t('Reservation-Requests')"
                              outlined
                              rows="4"
                              class="modern-input"
                            ></v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-tab-item>

              <!-- PASAPORT -->
              <v-tab-item :id="'1'" class="tab-panel">
                <v-layout row wrap>
                  <v-flex xs12 md8 pa-2>
                    <v-card class="modern-card" flat>
                      <div class="section-head">
                        <div>
                          <h3>{{$t('Passport-Information')}}</h3>
                          <span>{{$t('Document-Type,-Duration-and-Issuance-Fields')}}</span>
                        </div>
                      </div>

                      <v-card-text class="modern-card__body">
                        <v-layout row wrap>
                          <v-flex xs12 sm6>
                            <v-select
                              :items="itemspasaporttipi"
                              hide-details
                              v-model="Adres.PasaportTip"
                              item-text="text"
                              item-value="value"
                              :label="$t('Passport-Type')"
                              outlined
                              class="modern-input"
                            ></v-select>
                          </v-flex>

                          <v-flex xs12 sm6>
                            <v-text-field
                              hide-details
                              :label="$t('Passport-No')"
                              v-model="Adres.PasaportNo"
                              outlined
                              class="modern-input"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12>
                            <v-text-field
                              hide-details
                              :label="$t('Place-Issue')"
                              v-model="Adres.VerildigiYer"
                              outlined
                              class="modern-input"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 sm6>
                            <tarihim
                              :etiket="$t('Date-Issue')"
                              :value="Adres.VerilisTarihi"
                              :detaygizle="true"
                              v-model="Adres.VerilisTarihi"
                              :defaultvalue="'no'"
                            ></tarihim>
                          </v-flex>

                          <v-flex xs12 sm6>
                            <tarihim
                              :etiket="$t('Finishing-Date')"
                              :value="Adres.BitisTarihi"
                              :detaygizle="true"
                              v-model="Adres.BitisTarihi"
                              :defaultvalue="'no'"
                            ></tarihim>
                          </v-flex>

                          <v-flex xs12>
                            <v-select
                              :items="itemseskiyeni"
                              hide-details
                              v-model="Adres.EskiYeni"
                              item-text="text"
                              item-value="value"
                              clearable
                              :label="$t('Passport-Old-New')"
                              outlined
                              class="modern-input"
                            ></v-select>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>

                  <v-flex xs12 md4 pa-2>
                    <v-card class="modern-card modern-card--side" flat>
                      <div class="section-head">
                        <div>
                          <h3>{{$t('Childrens Information')}}</h3>
                          <span>{{$t('Passport-Scope-and-Visa-Requirements')}}</span>
                        </div>
                      </div>

                      <v-card-text class="modern-card__body">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-text-field
                              hide-details
                              mask="##################"
                              :label="$t('Children-Address-Code')"
                              v-model="Adres.Cocuk1Kod"
                              outlined
                              class="modern-input"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12>
                            <v-checkbox
                              :label="$t('Passport-Includes-Children')"
                              v-model="Adres.PspCocukVar"
                              hide-details
                              class="modern-check"
                            ></v-checkbox>
                          </v-flex>

                          <v-flex xs12>
                            <v-checkbox
                              :label="$t('Children-Require-Visa')"
                              v-model="Adres.PspCocukVizeIstiyor"
                              hide-details
                              class="modern-check"
                            ></v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-tab-item>

              <!-- DEPARTMAN -->
              <v-tab-item :id="'2'" class="tab-panel">
                <v-layout row wrap>
                  <v-flex xs12 md8 pa-2>
                    <v-card class="modern-card" flat>
                      <div class="section-head">
                        <div>
                          <h3>Departman Bilgileri</h3>
                          <span>Kurumsal yapı ve bağlı alanlar</span>
                        </div>
                      </div>

                      <v-card-text class="modern-card__body">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <cariaracomp
                              :etiket="$t('Cost-Current')"
                              :value="Adres.dptCariKod.kod"
                              v-model="Adres.dptCariKod.kod"
                              :Coper="true"
                            ></cariaracomp>
                          </v-flex>

                          <v-flex xs12 sm6>
                            <geneltipara v-model="Adres.dptBolge" tip="Bölge"></geneltipara>
                          </v-flex>

                          <v-flex xs12 sm6>
                            <geneltipara v-model="Adres.dptYonetim" tip="Yönetim"></geneltipara>
                          </v-flex>

                          <v-flex xs12 sm6>
                            <geneltipara v-model="Adres.dptDepartman" tip="Departman"></geneltipara>
                          </v-flex>

                          <v-flex xs12 sm6>
                            <geneltipara v-model="Adres.dptAltDepartman" tip="Alt Departman"></geneltipara>
                          </v-flex>

                          <v-flex xs12 sm6>
                            <geneltipara v-model="Adres.dptBolum" tip="Bölüm"></geneltipara>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-tab-item>

              
            </v-tabs>
          </v-flex>

          <v-dialog v-model="dialogfiltre" scrollable max-width="500px">
            <v-card flat color="grey lighten-5">
              <v-card-title>{{ $t('Term-Type-Explanations') }}</v-card-title>
              <v-divider></v-divider>

              <v-card-text>
                <v-flex xs12>
                  <v-list two-line>
                    <template v-for="(item, index) in vadetipi">
                      <v-subheader v-if="item.header" :key="item.header"></v-subheader>
                      <v-divider v-else-if="item.divider" :key="index" :inset="item.inset"></v-divider>

                      <v-list-tile v-else :key="item.title">
                        <v-list-tile-avatar>{{item.value}}</v-list-tile-avatar>
                        <v-list-tile-content>
                          <span class="caption">{{item.text}}</span>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list>
                </v-flex>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialogfiltre=false">
                  {{$t('Close')}}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-form>

      <v-snackbar
        :timeout="timeout"
        :top="y === 'top'"
        :bottom="y === 'bottom'"
        :right="x === 'right'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :vertical="mode === 'vertical'"
        v-model="snackbar"
        class="modern-snackbar"
      >
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>

<script>
import parainput from '../../customcomp/parainput'
import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"
import tarihim from "@/components/app/customcomp/tarihim.vue"
import tool from "../../coper/tools";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp.vue"
import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'

export default {
  data() {
    return {
      islem: 'yeni',
      loadingvmodel: false,
      loadingmesaj: null,

      prevRoute: null,
      mukellefScroll: false,
      hesapgurubu: [],
      dialogfiltre: false,
      cokluposta: false,
      postaitems: [],
      valid: true,
      tabcontrol3: 0,
      drawer: null,
      baslik: '',
      e1: 0,
      Code: '',
      e2: true,
      yok: false,
      statecari: [],
      search: '',
      search1: '',
      loading: false,

      Adres: {
        CreatedBy: null,
        CreatedDate: null,
        ModifiedBy: null,
        ModifiedDate: null,
        PspOfsTeslimAlan: null,
        PspOfsTeslimTarihi: null,
        PspMusTeslimEden: null,
        PspMusTeslimTarihi: null,
        dptBolge: { id: null, kod: null, isim: null, tip: null },
        dptYonetim: { id: null, kod: null, isim: null, tip: null },
        dptDepartman: { id: null, kod: null, isim: null, tip: null },
        dptAltDepartman: { id: null, kod: null, isim: null, tip: null },
        dptBolum: { id: null, kod: null, isim: null, tip: null },
        dptCariKod: { id: null, kod: null, isim: null, tip: null },
        SicilID: null,
        Id: 0,
        Kategori: null,
        Ad: null,
        Soyad: null,
        Adres: null,
        DogumTarihi: null,
        Ulke: null,
        Sehir: null,
        Meslek: null,
        Telefon1: null,
        Telefon2: null,
        GSM: null,
        Email: null,
        PasaportTip: 0,
        PasaportNo: null,
        VerildigiYer: null,
        VerilisTarihi: null,
        BitisTarihi: null,
        Sigara: null,
        Notlar: null,
        USAVize: null,
        USABitis: null,
        AnneAdi: null,
        BabaAdi: null,
        TCKimlikNo: null,
        DogumYeri: null,
        Kod: 0,
        Cinsiyet: null,
        RezIstekleri: null,
        SirketNo: null,
        UyeNo: null,
        PspCocukVar: false,
        PspCocukVizeIstiyor: false,
        Cocuk1Kod: null,
        OnlineCIn: false,
        OzelGun1: null,
        OzelGun2: null,
        OzelGun3: null,
        OzelGun4: null,
        OzelGun5: null,
        EskiYeni: null,
        Uyruk: null
      },

      itemscinsiyet: [
        { text: this.$t('Male'), value: 1 },
        { text: this.$t('Female'), value: 2 }
      ],

      itemspasaporttipi: [
        { text: 'Normal', value: 0 },
        { text: this.$t('Green'), value: 1 },
        { text: this.$t('Diplomatic'), value: 2 },
        { text: this.$t('Other'), value: 3 }
      ],

      itemseskiyeni: [
        { text: this.$t('Old'), value: 0 },
        { text: this.$t('New'), value: 1 }
      ],

      vadetipi: [],
      dictionary: {
        custom: {}
      },
      text1: '',
      snackbar: false,
      y: 'top',
      x: 'right',
      mode: '',
      timeout: 6000,
      active: '0'
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.path
    })
  },

  mounted() {
    if (this.$validator && this.dictionary) {
      this.$validator.localize('en', this.dictionary)
    }

    if (this.$route.query.isl == 'get') {
      this.islem = 'get'

      if (this.$route.query.id != null && this.$route.query.id != undefined) {
        this.loadingvmodel = true

        let params = { Id: this.$route.query.id }

        tool.http_post(this, 'AdresLoad', params).then(
          response => {
            this.loadingvmodel = false

            if (response.body.Status == true) {
              this.Adres = response.body.data
            } else {
              this.text1 = response.body.ErrorList[0]
              this.snackbar = true
            }
          },
          () => {
            this.loadingvmodel = false
            this.text1 = 'Hata Oluştu, tekrar deneyiniz'
            this.snackbar = true
          }
        )
      } else {
        this.text1 = 'Hatalı işlem id boş olamaz'
        this.snackbar = true
      }
    } else {
      this.islem = 'yeni'
    }
  },

  methods: {
    ekle,
    guncelle
  },

  beforeMount() {},

  components: {
    parainput,
    yuzdeinput,
    tarihim,
    genelarama,
    geneltipara,
    loadingcomp,
    cariaracomp
  }
}

function ekle() {
  if (this.$refs.formadres.validate()) {
    this.loadingvmodel = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.Adres.SirketNo = credentials ? credentials.CoperSirketNo : null

    var params = {
      Value: this.Adres
    }

    tool.http_post(this, 'AdresInsert', params).then(
      response => {
        this.loadingvmodel = false

        if (response.body.Status == true) {
          this.text1 = 'Kayıt Eklendi'
          this.snackbar = true
          this.Adres = response.body.data
        } else {
          this.text1 = response.body.ErrorList[0]
          this.snackbar = true
        }
      },
      () => {
        this.loadingvmodel = false
        this.text1 = 'Hata Oluştu, tekrar deneyiniz'
        this.snackbar = true
      }
    )
  } else {
    this.active = '0'
  }
}

function guncelle() {
  if (this.$refs.formadres.validate()) {
    this.loadingvmodel = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.Adres.SirketNo = credentials ? credentials.CoperSirketNo : null

    var params = {
      Value: this.Adres
    }

    tool.http_post(this, 'AdresUpdate', params).then(
      response => {
        this.loadingvmodel = false

        if (response.body.Status == true) {
          this.text1 = 'Kayıt Güncellendi'
          this.snackbar = true
          this.Adres = response.body.data
        } else {
          this.text1 = response.body.ErrorList[0]
          this.snackbar = true
        }
      },
      () => {
        this.loadingvmodel = false
        this.text1 = 'Hata Oluştu, tekrar deneyiniz'
        this.snackbar = true
      }
    )
  } else {
    this.active = '0'
  }
}
</script>

<style scoped>
.adres-page {
  min-height: 100vh;
  padding: 20px;
  background:
    radial-gradient(circle at top left, rgba(37, 99, 235, 0.08), transparent 28%),
    radial-gradient(circle at top right, rgba(14, 165, 233, 0.08), transparent 24%),
    linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
}

.page-shell {
  background: transparent !important;
}

.hero-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 24px 28px;
  margin-bottom: 18px;
  border-radius: 24px;
  background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 55%, #2563eb 100%);
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.20);
}

.hero-bar__badge {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .4px;
  color: #dbeafe;
  background: rgba(255, 255, 255, 0.14);
}

.hero-bar__title {
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  color: #fff;
}

.hero-bar__subtitle {
  margin: 6px 0 0;
  color: rgba(255, 255, 255, 0.78);
  font-size: 14px;
}

.hero-bar__right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.action-btn {
  border-radius: 14px !important;
  text-transform: none !important;
  font-weight: 700;
  letter-spacing: 0 !important;
  box-shadow: none !important;
}

.action-btn--save,
.action-btn--update {
  background: #ffffff !important;
  color: #0f172a !important;
}

.modern-tabs {
  background: transparent !important;
}

.modern-tabs .v-tabs__bar {
  background: rgba(255,255,255,0.65) !important;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 18px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
  margin-bottom: 18px;
}

.modern-tabs .v-tab {
  text-transform: none !important;
  font-weight: 700;
  color: #334155 !important;
}

.tab-panel {
  padding-top: 8px;
}

.modern-card {
  border-radius: 22px !important;
  border: 1px solid rgba(148, 163, 184, 0.16);
  background: rgba(255,255,255,0.88) !important;
  backdrop-filter: blur(10px);
  box-shadow: 0 12px 35px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.modern-card--side {
  height: 100%;
}

.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 24px 14px;
}

.section-head h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: #0f172a;
}

.section-head span {
  display: block;
  margin-top: 4px;
  color: #64748b;
  font-size: 13px;
}

.modern-card__body {
  padding: 8px 18px 22px !important;
}

.modern-input {
  margin-bottom: 10px;
}

.check-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 2px 14px;
}

.modern-check {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.modern-snackbar {
  z-index: 9999;
}

@media (max-width: 960px) {
  .hero-bar {
    flex-direction: column;
    align-items: flex-start;
  }

  .hero-bar__right {
    width: 100%;
    justify-content: flex-start;
  }
}
</style>